module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_5.6f301a79.png";